import { SequenceLibrary, SequenceTemplate } from '@types'

import { Container, SequenceTemplateLine, TaskTemplateDot } from './SequenceTemplatePreview.styled'

interface Props {
  sequence: SequenceTemplate | SequenceLibrary
  size?: 'small' | 'medium' | 'tall'
}

export const SequenceTemplatePreview = (props: Props): JSX.Element => {
  const {
    sequence: { tasks },
    size = 'medium',
  } = props

  return (
    <Container size={size}>
      <SequenceTemplateLine size={size}>
        {[...Array(9)].map((_, index) => {
          const task = tasks.find(
            (t) => t.startRow == 0 && index >= t.startDay && index <= t.startDay + Math.ceil(t.duration) - 1,
          )

          return (
            <TaskTemplateDot
              key={`${index}`}
              size={size}
              style={{ backgroundColor: task ? task.trade.color || 'black' : undefined }}
            />
          )
        })}
      </SequenceTemplateLine>
      <SequenceTemplateLine size={size}>
        {[...Array(9)].map((_, index) => {
          const task = tasks.find(
            (t) => t.startRow == 1 && index >= t.startDay && index <= t.startDay + Math.ceil(t.duration) - 1,
          )

          return (
            <TaskTemplateDot
              key={`${index}`}
              size={size}
              style={{ backgroundColor: task ? task.trade.color || 'black' : undefined }}
            />
          )
        })}
      </SequenceTemplateLine>
      <SequenceTemplateLine size={size}>
        {[...Array(9)].map((_, index) => {
          const task = tasks.find(
            (t) => t.startRow == 2 && index >= t.startDay && index <= t.startDay + Math.ceil(t.duration) - 1,
          )

          return (
            <TaskTemplateDot
              key={`${index}`}
              size={size}
              style={{ backgroundColor: task ? task.trade.color || 'black' : undefined }}
            />
          )
        })}
      </SequenceTemplateLine>
    </Container>
  )
}
